"use client";

import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { usePathname } from "next/navigation";
import { getBannerData } from "../api/service/homepage";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import { useAuth } from "@/context/authcontext";
import { DirectPaths } from "@/config/routes";
import { ICM_ADVISORY } from "../utils/constants";
import { getBannerLinkInfo, setXPartnerfromQueryString } from "../utils/helper";

export default function Banner() {
    const { isAuthenticated } = useAuth();
    const pathname = usePathname();
    const [queryParams, setQueryParams] = useState<{ xPlatform?: string; partner?: string }>({});

    useEffect(() => {
        if (typeof window !== "undefined") {
            const params = new URLSearchParams(window.location.search);
            setQueryParams({
                xPlatform: params.get("xPlatform") || undefined,
                partner: params.get("partner") || undefined,
            });

            setXPartnerfromQueryString();
        }
    }, []);

    const { data: bannerData, isLoading } = useQuery({
        queryKey: ["bannerListData"],
        queryFn: getBannerData,
    });

    // hide banner if advisory
    if (queryParams.xPlatform === ICM_ADVISORY || queryParams.partner === ICM_ADVISORY) {
        return null;
    }

    const isAllowedPaths =
        [DirectPaths.HOME, DirectPaths.UNLISTED_SHARES].includes(pathname as DirectPaths) ||
        (typeof window !== "undefined" &&
            window.location.href === `${process.env.ICM_URL}${DirectPaths.PLATFORM}`);
    
    if (isLoading) {
        return (
            <div className="h-[86px] animate-pulse bg-banner-gradient px-s9 xs:h-[67px] sm:h-[78px]" />
        );
    }

    const bannerLink = bannerData?.data?.[0]?.bannerLink;
    const { isOtherDomain } = getBannerLinkInfo(bannerLink);

    return (
        (!isAuthenticated || isAllowedPaths) &&
        bannerData?.data?.length > 0 && (
            <a
                href={`${bannerData.data[0]?.bannerLink}`}
                target={isOtherDomain ? "_blank" : "_self"}
                rel={isOtherDomain ? "noopener noreferrer" : ""}
                onClick={() =>
                    setAnalyticsEvent(`${bannerData.data[0]?.bannerLink}`, "Home_banner")
                }
            >
                <div className="bg-banner-gradient px-s9 py-s7 text-white md:py-s8">
                    <div className="md:px-auto mx-auto max-w-[100%] md:container md:px-6">
                        <div className="animate-fade flex items-center justify-between text-xs md:text-base">
                            {bannerData.data[0]?.bannerText}
                            <RegularButton
                                noIcon
                                showRightIcon={false}
                                size={ButtonSize.Small}
                                variant={ButtonVariant.SecondaryDefault}
                                className="bg-white md:block"
                                label="Invest Now"
                            />
                        </div>
                    </div>
                </div>
            </a>
        )
    );
}